export default __webpack_public_path__ + "static/media/component_template.ed14873a.xlsx";